module.exports = __webpack_public_path__ + "img/eng.af5223e9.svg";